import { getHeadElement } from "@gr-exports/async/dom";
import { RequestError } from "@gr-exports/async/errors";

/**
 *
 */
export interface InjectScriptOptions {
  /**
 *
 *
 *
 *
 */
  immediately?: boolean;

  /**
 *
 *
 *
 *
 */
  cacheBusting?: boolean | string;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  type?: "module" | "sync" | false | (string & {});

  /**
 *
 *
 *
 *
 */
  attributes?: Record<string, string>;

  /**
 *
 *
 *
 *
 */
  remove?: boolean | number;

  /**
 *
 *
 *
 *
 */
  target?: HTMLHeadElement | HTMLBodyElement | HTMLElement;
}

/**
 *
 *
 *
 */
export type Result<E, R> = [error: E, result: undefined] | [error: undefined, result: R];

export function setScriptType(
  script: HTMLScriptElement,
  type: NonNullable<InjectScriptOptions["type"]>,
): void {
  if (type === false) return;
  if (type === "sync") {
    script.type = "text/javascript";
    return;
  }
  script.type = type;
}

export function setCacheBusting(url: URL, cacheBusting?: boolean | string): void {
  if (!cacheBusting) return;
  const paramName = typeof cacheBusting === "string" ? cacheBusting : "_";
  url.searchParams.set(paramName, String(Date.now()));
}

export function isStatusCodeInvalid(status: number): boolean {
  if (status === 304) return false; /*           */
  return status < 200 || status >= 299; /*                                       */
}

export async function getScript(
  url: string | URL,
  options: InjectScriptOptions = {},
  requestInit: RequestInit = {},
): Promise<HTMLScriptElement> {
  /*                                 */
  const scriptUrl = new URL(url, window.location.href);
  setCacheBusting(scriptUrl, options.cacheBusting);

  /*                                              */
  const init = { method: "GET", ...requestInit };
  const response = await fetch(scriptUrl, init);

  /*                              */
  if (isStatusCodeInvalid(response.status))
    throw new RequestError(
      `Failed to fetch script from: ${url} due to invalid status code: ${response.status}`,
      response,
    );

  const {
    attributes = {},
    immediately = true,
    remove = true,
    type = "module",
    target = getHeadElement(),
  } = options;

  /*                                          */
  const scriptText = await response.text();

  /*                                             */
  const script = document.createElement("script");
  script.text = scriptText;
  setScriptType(script, type);

  /*                                        */
  Object.entries(attributes).forEach(([key, value]) => {
    script.setAttribute(key, value);
  });

  /*                                                      */
  if (!immediately) return script;

  /*                                                  */
  target.appendChild(script);

  /*                                      */
  if (!remove) return script;

  /*                           */
  /*                                         */
  const removeTimeout = typeof remove === "number" ? remove : script.type === "module" ? 100 : 0;
  /*                                                       */
  setTimeout(() => target.removeChild(script), removeTimeout);

  return script;
}

export async function getScriptSafe(
  url: string | URL,
  options: InjectScriptOptions = {},
  requestInit: RequestInit = {},
): Promise<Result<RequestError | Error, HTMLScriptElement>> {
  try {
    return [undefined, await getScript(url, options, requestInit)];
  } catch (error) {
    return [error as never, undefined];
  }
}
